$(document).ready(function () {
  const $header = $('.site-header');
  const $group = $('.account-link');
  const $dropdown = $('.account-link-dropdown');

  if ($header.length === 0 || $group.length === 0 || $dropdown.length === 0) return;

  // Add class when hovering over group or dropdown
  $group.on('mouseenter', function () {
    $dropdown.addClass('active');
  });

  $dropdown.on('mouseenter', function () {
    $dropdown.addClass('active');
  });

  // Remove class only when mouse fully leaves the header
});
